import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTruenasComponent } from './simple-icons-truenas.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTruenasComponent ],
    exports:      [ SimpleIconsTruenasComponent ],
    bootstrap:    []
})
export class SimpleIconsTruenasModule {}
